export const StockYears = [
  { id: 'Less_than_1_year', name: 'Less than 1 year', code: '1' },
  { id: '1_5_years', name: '1-5 years', code: '2' },
  { id: 'More_than_5_years', name: 'More than 5 years', code: '3' }
];

export const StockAnnualTrades = [
  { id: '10_trades_or_less', name: '10 trades or less', code: '10' },
  { id: '11_to_25_trades', name: '11 to 25 trades', code: '25' },
  { id: '26_to_50_trades', name: '26 to 50 trades', code: '50' },
  { id: '51_or_more_trades', name: '51 or more trades', code: '51' }
];

export const StockAverageTradeSize = [
  { id: '1000_or_less', name: '$1,000 or less', code: '1000' },
  { id: '1001_5000', name: '$1,001 - $5,000', code: '5000' },
  { id: '5001_25000', name: '$5,001 - $25,000', code: '25000' },
  { id: '25001_or_more', name: '$25,001 or more', code: '25001' }
];
